import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GoogleOAuthCallbackView } from '@/components/auth/GoogleOAuthCallbackView';
import { useGoogleOAuthCallback } from '@/hooks/useGoogleOAuthCallback';

export const Route = createFileRoute('/auth/google/callback/')({
  component: GoogleOAuthCallbackPage,
});

function GoogleOAuthCallbackPage() {
  const navigate = useNavigate();

  const onRedirect = useCallback(
    (path: string) => {
      const [pathname, search = ''] = path.split('?');
      const searchParams = Object.fromEntries(new URLSearchParams(search));
      navigate({
        to: pathname || '/profile',
        search: searchParams,
        replace: true,
      });
    },
    [navigate],
  );

  const { status, errorMessage, connectionType } = useGoogleOAuthCallback(onRedirect);

  return (
    <GoogleOAuthCallbackView
      status={status}
      errorMessage={errorMessage}
      connectionType={connectionType}
      onBack={() => navigate({ to: '/profile', replace: true })}
      onRetry={() => window.location.reload()}
    />
  );
}
